import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <main style={{ 
            padding: "1rem", 
            display:"flex", 
            flexDirection:"column", 
            justifyContent:"center", 
            alignItems:"center", 
            height:"100vh",
        }}>
            <h1>Welcome to J software</h1>
            <p>There's nothing here!</p>
            <Link to="/"><p>Click here!</p></Link>
            <br />
            <Link to="/company"><p>|------------ company info ------------|</p></Link>
            <Link to="/portfolio"><p>|--------------- business ---------------|</p></Link>
        </main>
    )
}

export default NotFound;